import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BackComponent } from '../../../../shared/components/back/back.component';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  imports: [TranslateModule, BackComponent, RouterLink, NgClass],
  templateUrl: './privacy-policy.component.html',
})
export class PrivacyPolicyComponent {
  get lang() {
    return localStorage.getItem('lang');
  }

  get isRTL() {
    return this.lang === 'ar';
  }
}
